<template>
  <div>
    <a-card class="style1 pages w-100" :class="[isDesktop ? 'desktop' : 'mobile']">
      <a-form :form="form" :label-col="isDesktop ? { span: 4 } : {}" :wrapper-col="isDesktop ? { span: 20 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
        <a-form-item label="Ai Control Prompt">
          <wysiwyg
            v-model="control_prompt"
            v-decorator="[
              'control_prompt',
              {
                rules: [
                  {
                    required: true,
                    validator: (rule, value, callback) => validateInput(rule, value, callback, 'Please input the controller prompt!'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-button type="primary" html-type="submit" :loading="isLoading">{{ 'Save' }}</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AdminService from '@/services/AdminService';
import { empty } from '@/utils';
import { get } from 'lodash';
export default {
  data() {
    return {
      showPreview: false,
      error: '',
      pageInfo: {},
      isLoading: false,
      control_prompt: '',
      filter_rules: '',
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'page',
    });
  },
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  watch: {
    $route: {
      async handler() {
        this.doGetInfo();
      },
      immediate: true,
    },
  },
  mounted() {
    this.$title = this.$route.meta.title;
  },
  methods: {
    async doGetInfo() {
      try {
        this.isLoading = true;
        const resp = await AdminService.aiControl.get();
        this.control_prompt = resp.control_prompt;
        this.filter_rules = resp.filter_rules;
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },

    validateInput(rule, value, callback, message) {
      if (empty(value) || value === '<br>') {
        return callback(message);
      }
      callback();
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            this.error = '';
            const dataSubmit = { filter_rules: this.filter_rules };
            const paramsRequired = ['control_prompt'];

            paramsRequired.forEach(item => {
              if (!empty(values[item])) {
                dataSubmit[item] = values[item];
              }
            });
            await AdminService.aiControl.update(dataSubmit);
            this.$notification['success']({
              message: 'Update successful.',
              content: `${dataSubmit.title} was updated successfully.`,
            });
          } catch (error) {
            console.log(error);
            this.error = get(error, 'response.data.error', error.message);
          } finally {
            this.isLoading = false;
          }
        } else {
          window.parent.scrollTo(0, 0);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<style lang="scss">
.pages {
  &.mobile {
    .editr--toolbar {
      height: 100%;
      flex-wrap: wrap;
      .vw-btn-separator {
        display: none;
      }
    }
  }
}
</style>
